import { __decorate } from "tslib";
import __NG_CLI_RESOURCE__0 from "./calcite-card.component.html?ngResource";
import __NG_CLI_RESOURCE__1 from "./calcite-card.component.css?ngResource";
import { Component, Input } from '@angular/core';
let CalciteCardComponent = class CalciteCardComponent {
    cardTitle = "";
    constructor() {
    }
    ngOnInit() {
    }
    static ctorParameters = () => [];
    static propDecorators = {
        cardTitle: [{ type: Input }]
    };
};
CalciteCardComponent = __decorate([
    Component({
        selector: 'lib-calcite-card',
        template: __NG_CLI_RESOURCE__0,
        styles: [__NG_CLI_RESOURCE__1]
    })
], CalciteCardComponent);
export { CalciteCardComponent };
